import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="col00">
        <div class="heading01 type01">
            <h1>{{ 'formCategory.Manage form categories' | translate }}</h1>
            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn add" ng-click="vm.addCategory()">{{ 'formCategory.Add category' | translate }}</a>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <table class="data01" datatable dt-options="vm.DATATABLES">
                <thead>
                    <tr>
                        <th ng-class="vm.list.getSortClass('name')"><a ng-click="vm.list.sortBy('name')">{{ 'formCategory.Name' | translate }}</a></th>
                        <th>{{ 'formCategory.Form count' | translate }}</th>
                        <th ng-class="vm.list.getSortClass('status')"><a ng-click="vm.list.sortBy('status')">{{ 'formCategory.Status' | translate }}</a></th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat-start="item in vm.list.items" ng-class="{status04: item.status === vm.FORMS_CATEGORY_FORMS_ENUM.KEYS.INACTIVE}">
                        <td><a ui-sref="authorized.forms.settings.formcategories.edit({ id: item.id })">{{ item.activeI18n.name }}</td>
                        <td>{{ item.formCount }}</td>
                        <td>{{ vm.FORMS_CATEGORY_FORMS_ENUM.LABELS[item.status] }}</td>
                        <td class="actions">
                            <a class="btn edit" ui-sref="authorized.forms.settings.formcategories.edit({ id: item.id })">{{ 'general.Edit' | translate }}</a>
                            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn delete" ng-click="vm.deleteCategory(item.id)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-repeat-start="l2item in item.childCategories" class="level02" ng-class="{status04: l2item.status === vm.FORMS_CATEGORY_FORMS_ENUM.KEYS.INACTIVE}">
                        <td><a ui-sref="authorized.forms.settings.formcategories.edit({ id: l2item.id })">{{ l2item.activeI18n.name }}</td>
                        <td>{{ l2item.formCount }}</td>
                        <td>{{ vm.FORMS_CATEGORY_FORMS_ENUM.LABELS[l2item.status] }}</td>
                        <td class="actions">
                            <a class="btn edit" ui-sref="authorized.forms.settings.formcategories.edit({ id: l2item.id })">{{ 'general.Edit' | translate }}</a>
                            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn delete" ng-click="vm.deleteCategory(l2item.id)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-repeat-start="l3item in l2item.childCategories" class="level03" ng-class="{status04: l3item.status === vm.FORMS_CATEGORY_FORMS_ENUM.KEYS.INACTIVE}">
                        <td><a ui-sref="authorized.forms.settings.formcategories.edit({ id: l3item.id })">{{ l3item.activeI18n.name }}</td>
                        <td>{{ l3item.formCount }}</td>
                        <td>{{ vm.FORMS_CATEGORY_FORMS_ENUM.LABELS[l3item.status] }}</td>
                        <td class="actions">
                            <a class="btn edit" ui-sref="authorized.forms.settings.formcategories.edit({ id: l3item.id })">{{ 'general.Edit' | translate }}</a>
                            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn delete" ng-click="vm.deleteCategory(l3item.id)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-repeat-start="l4item in l3item.childCategories" class="level04" ng-class="{status04: l4item.status === vm.FORMS_CATEGORY_FORMS_ENUM.KEYS.INACTIVE}">
                        <td><a ui-sref="authorized.forms.settings.formcategories.edit({ id: l4item.id })">{{ l4item.activeI18n.name }}</td>
                        <td>{{ l4item.formCount }}</td>
                        <td>{{ vm.FORMS_CATEGORY_FORMS_ENUM.LABELS[l4item.status] }}</td>
                        <td class="actions">
                            <a class="btn edit" ui-sref="authorized.forms.settings.formcategories.edit({ id: l4item.id })">{{ 'general.Edit' | translate }}</a>
                            <a ng-if="vm.QuestionService.canManageQuestionRelatedData()" class="btn delete" ng-click="vm.deleteCategory(l4item.id)">{{ 'general.Delete' | translate }}</a>
                        </td>
                    </tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td></tr>
                    <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td></tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    </div>
    `
})
export default class {
    constructor ($translate, ListFactory, ModalService, QuestionService, FormCategoryResource, DATATABLES, FORMS_CATEGORY_FORMS_ENUM) {
        this.$translate = $translate;
        this.FormCategoryResource = FormCategoryResource;
        this.DATATABLES = DATATABLES;
        this.FORMS_CATEGORY_FORMS_ENUM = FORMS_CATEGORY_FORMS_ENUM;
        this.ModalService = ModalService;
        this.QuestionService = QuestionService;
        this.list = ListFactory.createWithPagination(FormCategoryResource.tree.bind(FormCategoryResource));
        this.list.fetch();
    }

    addCategory () {
        return this.ModalService.open({
            size: 'large',
            template: `
                <forms-settings-formcategories-add ok="vm.$uibModalInstance.close()" cancel="vm.$uibModalInstance.dismiss()"></forms-settings-formcategories-add>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(() => {
            this.list.fetch();
        });
    }

    deleteCategory (id) {
        this.ModalService.confirm(
            this.$translate.instant('formCategory.Are you sure you want to delete this category? Subcategories will be also deleted')
            , 'large'
        ).then(() => {
            this.FormCategoryResource.delete({ id }).$promise.then(() => {
                this.list.fetch();
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/formcategories/list/index.js